export default "__VITE_ASSET__C8vI055C__"